export default function Page() { return <div>ElectionCorner Page</div>; }